import OnboardingMessagesConfig from './OnboardingMessagesConfig';

export default OnboardingMessagesConfig;
